import { render, staticRenderFns } from "./TabWeight.vue?vue&type=template&id=cc236e68&scoped=true&"
import script from "./TabWeight.vue?vue&type=script&lang=js&"
export * from "./TabWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc236e68",
  null
  
)

export default component.exports